import {
  useAuthStore,
  type AuthenticatedUser,
  type UserRole,
} from "@/stores/authStore";

/**
 * Routes that only operators (admins) may see. Customers/members get the 403
 * page if they deep-link to one, and these are hidden from their navigation.
 * Single source of truth shared by the nav (DashboardLayout) and RoleGuard.
 */
// NOTE: /audit is intentionally NOT here — the backend scopes audit reads to the
// caller's own project, so members may see their own activity log (v6 parity).
export const ADMIN_PATHS = [
  "/identity",
  "/machines",
  "/maintenance",
  "/agent-gateway-fleet",
  "/optimization",
  "/monitoring",
  "/logs",
] as const;

/** Whether a user holds the operator (admin) role. */
export function isAdmin(user: AuthenticatedUser | null | undefined): boolean {
  return user?.role === "admin";
}

/** Reactive admin check for components, backed by the auth store. */
export function useIsAdmin(): boolean {
  return useAuthStore((state) => isAdmin(state.user));
}

export type { UserRole };
